import styled, {useTheme} from "styled-components";
import {useLocation, NavLink} from "react-router-dom";
import {Hamburger as HamburgerIcon} from "../icons/Hamburger";
import React, {useEffect, useState} from "react";
import {MenuX as CloseIcon} from "../icons/MenuX";
import {device} from "../../theme";

const menu = [
    {
        path: "/",
        name: "Konkurranser"
    },
    {
        path: "/mesterskap",
        name: "Mesterskap"
    },
    {
        path: "/hederstegn",
        name: "Hederstegn"
    },
    {
        path: "/statistikk",
        name: "Statistikk"
    },

]


const activeClassName = "any";

export const Menu = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const theme = useTheme();
    function useImperativeDisableScroll({ element, disabled }) {
        useEffect(() => {
            if (!element) return
            element.style.overflowY = disabled ? 'hidden' : 'scroll'
            return () => element.style.overflowY = 'scroll'
        }, [disabled])
    }
    useImperativeDisableScroll({ element: document.body, disabled: isMobileMenuOpen })
    return <>
        <SubMenu>
            {menu.map(item => (
                <NavLinkSecondary
                    key={item.path}
                    to={`${item.path}`}
                    activeClassName={activeClassName}
                >
                    {item.name}
                </NavLinkSecondary>
            ))}
        </SubMenu>
        {isMobileMenuOpen && <MobileMenu>
            <MenuButton onClick={() => setIsMobileMenuOpen(false)}>
                <CloseIcon stroke={theme.text.color.link}/>
            </MenuButton>
            <MobileMenuBackdrop/>
            <MobileSub>
                {menu.map(item => (
                    <NavLinkSecondary
                        key={item.path}
                        to={`${item.path}`}
                        activeClassName={activeClassName}
                    >
                        {item.name}
                    </NavLinkSecondary>
                ))}
            </MobileSub>
        </MobileMenu>
        }
        {!isMobileMenuOpen &&
            <MenuButton onClick={() => setIsMobileMenuOpen(true)}>
                <HamburgerContainer>
                    <HamburgerIcon stroke={theme.text.color.link}/>
                </HamburgerContainer>
            </MenuButton>
        }
    </>
}

const MobileMenu = styled.div`
  overflow: hidden;
  `

const MobileSub = styled.div`
  z-index: 20;
  position: fixed;
  top: 70px;
  display: flex;
  flex-direction: column;
`

const SubMenu = styled.nav`
  height: 3.125rem;
  background-color: ${(props) => props.theme.color.primary.xxxlight};
  display: flex;
  align-items: center;
  padding: 0 3.125rem;

  > * {
    margin-right: 1.875rem;
  }

  @media (max-width: 912px) {
    display: none;
  }
`;

const NavLinkSecondary = styled(NavLink).attrs({
    activeClassName,
})`
  color: ${(props) => props.theme.text.color.link};
  font-weight: ${(props) => props.theme.font.t["font-weight"]};
  font-family: ${(props) => props.theme.font.t["font-family"]};
  text-decoration: none;

  opacity: 0;
  animation: fadeIn 200ms ease forwards;

  &.${activeClassName} {
    font-weight: ${(props) => props.theme.font.tb["font-weight"]};
  }

  @media ${device.mobile} {
    margin-top: 10px;
    font-size: 1.5rem;
  }
`;

const MobileHeader = styled.nav`
  height: 4rem;
  background-color: ${(props) => props.theme.header.background.color};
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 0.625rem 0;
  display: flex;
  z-index: 99;

  &.header-closed {
    @media (min-width: 913px) {
      display: none;
    }
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  align-items: center;
  right: 15px;
  top: 30px;
  z-index: 99;

  > * {
    margin-left: 0.3rem;
  }
  
  @media not (${device.mobile}) {
    display: none;
  }

}
`;

const HamburgerContainer = styled.div`
  position: relative;
  top: -0.1rem;
  left: -0.1rem;
`;

const MobileMenuBackdrop = styled.section`
  position: fixed;
  top: 70px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${(props) => props.theme.header.background.color};
  z-index: 10;
`;